import { Component, OnInit, OnDestroy, ViewChild } from '@angular/core';
import { NotifierService } from 'angular-notifier';
import { RestApiService } from '../rest-api.service';
import { Filters, Formatters } from 'angular-slickgrid';
import { MessageService } from '../message.service';
import { Router } from '@angular/router';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { Subscription } from 'rxjs';
import { CustomInputEditor } from '../custom-inputEditor';
import { FormControl } from '@angular/forms';


@Component({
    selector: 'app-category-client-module-new',
    templateUrl: './category-client-module-new.component.html',
    styleUrls: ['./category-client-module-new.component.css']
})
export class CategoryClientModuleNewComponent implements OnInit, OnDestroy {
    categoryLoaded: false;
    ticketTypes = [];

    areaSelected1: number;
    areas1 = [];
    areaSelected: number;
    parentSelected: number;
    show: boolean;
    dataset: any[];
    totalData: number;
    respObject: any;
    areas = [];
    parents = [];
    parentName: string;
    areaName: string;
    attrVal: string;
    attrDesc: string;
    displayData: any;
    add = false;
    del = false;
    edit = false;
    view = false;
    isError = false;
    errorMessage: string;
    private notifier: NotifierService;
    private clientId: number;
    private seq: number;
    tickets = [];
    ticketSelected: number;
    type: string;
    nextOffset: number;
    previousOffset: number;
    pageSize: number;
    paginationType: string;
    page_no: number;
    totalPage: number;
    private baseFlag: any;
    private userAuth: Subscription;
    offset: number;
    attachClaimNo: boolean;
    enablePriority: boolean;
    updateStatus = [];
    updateStatusSelected: string;
    fileUploadUrl: string;
    uploadButtonName = 'Upload File';
    attachment: any;
    uploadSuccessMessage: string;
    templateDownloadMessage: string;
    templatebtndisabled: boolean;
    ticketSelectedForTemplate: number;
    formData: any;
    dataLoaded: boolean;
    isShow = false;
    showSearch = true;
    isLoading = false;
    searchData: FormControl = new FormControl();
    categoryName: any;
    categorys: any;
    des: string;
    showExportBtn = false;
    dataExcel = [];
    @ViewChild('scarch_content') private scarch_content;
    private searchModalReference: NgbModalRef;
    icSelected: any;
    ics = [];
    isSearch = false;
    levels = [];
    levelSelected: any;
    showResetBtn: boolean;
    urgencieName: string;
    urgencies = [];
    categoryParentName: string;
    categories = [];
    priorityName: string;
    priorities = [];

    priorityType: number;
    prioritySelected: number;
    categorySelected: number;
    urgencySelected: number;
    impacts = [];
    impactSelected: number;
    id: number;
    selectedActionValue: number;
    constructor(private _rest: RestApiService, private messageService: MessageService, private route: Router,
        private modalService: NgbModal, notifier: NotifierService) {
        this.notifier = notifier;
        this.messageService.getCellChangeData().subscribe(item => {
            switch (item.type) {
                case 'change':
                    console.log('changed');
                    if (!this.messageService.edit) {
                        this.notifier.notify('error', 'You do not have edit permission');
                    } else {
                        const data = {
                            ATTRVAL: item.name, Attr_desc: item.description, user_id: this.messageService.getUserId(), id: item.id
                        };
                        console.log('data---' + JSON.stringify(data));
                        this._rest.updateTicketAttributesClientWise(data).subscribe((res) => {
                            this.respObject = res;
                            if (this.respObject.success) {
                                this.notifier.notify('success', 'Updated Successfully');
                            } else {
                                this.notifier.notify('error', this.respObject.errorMessage);
                            }
                        }, (err) => {
                            this.notifier.notify('error', this.respObject.errorMessage);
                        });
                    }
                    break;
                case 'delete':
                    // console.log('deleted');
                    if (!this.messageService.del) {
                        this.notifier.notify('error', 'You do not have delete permission');
                    } else {
                        if (confirm('Are you sure?')) {
                            this._rest.deleteTicketAttributesClientWise({
                                id: item.id,
                                user_id: this.messageService.getUserId()
                            }).subscribe((res) => {
                                this.respObject = res;
                                if (this.respObject.success) {
                                    // this.totalData = this.totalData - 1;
                                    // this.messageService.setTotalData(this.totalData);
                                    this.messageService.sendAfterDelete(item.id);
                                } else {
                                    this.notifier.notify('error', this.respObject.errorMessage);
                                }
                            }, (err) => {
                                this.notifier.notify('error', this.respObject.errorMessage);
                            });
                        }
                    }
                    break;
            }
        });
        // this.messageService.getUserAuth().subscribe(details => {
        //   console.log(JSON.stringify(details));
        //   if (details.length > 0) {
        //     this.add = details[0].addFlag;
        //     this.del = details[0].deleteFlag;
        //     this.view = details[0].viewFlag;
        //     this.edit = details[0].editFlag;
        //   } else {
        //     this.add = true;
        //     this.del = true;
        //     this.view = true;
        //     this.edit = true;
        //   }
        // });
    }


    ngOnInit() {
        this.id = 0;
        this.urgencieName = '';
        this.urgencies = [];
        this.categoryParentName = '';
        this.categories = [];
        this.priorityName = '';
        this.priorities = [];

        this.priorityType = 0;
        this.prioritySelected = 0;
        this.categorySelected = 0;
        this.urgencySelected = 0;
        this.impacts = [];
        this.impactSelected = 0;

        this.showResetBtn = true;
        this.icSelected = 0;
        this.levelSelected = 0;
        this.isShow = false;
        this.ticketSelected = 0;
        this.dataLoaded = false;

        this.templatebtndisabled = false;
        this.templateDownloadMessage = '';
        this.ticketSelectedForTemplate = 0;
        this.fileUploadUrl = this._rest.apiRoot + '/updateFile';

        this.nextOffset = 0;
        this.previousOffset = 0;
        this.pageSize = this.messageService.pageSize;
        this.page_no = 0;
        this.totalPage = 0;
        this.paginationType = 'next';
        this.selectedActionValue = 1;
        // this.getBaseParent();

        this.displayData = {
            pageName: 'Maintain Categories',
            openModalButton: 'Add Categories',
            searchModalButton: 'Search',
            breadcrumb: 'Categories',
            folderName: 'All Categories',
            tabName: 'Click "Search" Button to Display Data ',
            exportBtn: 'Export to excel'
        };
        let columnDefinitions = [];
        columnDefinitions = [
            // {
            //   id: 'delete',
            //   field: 'id',
            //   excludeFromHeaderMenu: true,
            //   formatter: Formatters.deleteIcon,
            //   minWidth: 30,
            //   maxWidth: 30,
            // },
            // {id: 'id', name: 'Id', field: 'id', sortable: true, maxWidth: 40, filterable: true},
            {
                id: 'ttype', name: 'Ticket Type', field: 'tickettype', sortable: true, filterable: true
            },

            {
                id: 'ares', name: 'Process Area ', field: 'area', sortable: true, filterable: true
            },
            {
                id: 'parent', name: 'Parent ', field: 'parent', sortable: true, filterable: true
            },
            {
                id: 'user', name: 'Name', field: 'name', sortable: true, filterable: true, cssClass: 'highlight', editor: {
                    model: CustomInputEditor,
                }
            },
            {
                id: 'Description',
                name: 'Description',
                field: 'description',
                sortable: true,
                filterable: true,
                cssClass: 'highlight',
                editor: {
                    model: CustomInputEditor,
                }
            },
            {
                id: 'prority', name: 'Ticket Priority ', field: 'prority', sortable: true, filterable: true
            }
        ];


        if (this.clientId === 2) {
            columnDefinitions.push({
                id: 'attachedField', name: 'Attached Field', field: 'attachedField', formatter: Formatters.checkmark,
                filter: {
                    collection: [{ value: '', label: 'All' }, { value: true, label: 'True' }, { value: false, label: 'False' }],
                    model: Filters.singleSelect,

                    filterOptions: {
                        autoDropWidth: true
                    },
                }, sortable: true, filterable: true, minWidth: 40, cssClass: 'highlight', editor: {
                    model: CustomInputEditor,
                }
            });
        }
        this.messageService.setColumnDefinitions(columnDefinitions);
        if (this.messageService.clientId) {
            this.clientId = this.messageService.clientId;
            this.baseFlag = this.messageService.baseFlag;
            this.onPageLoad();
        } else {
            this.userAuth = this.messageService.getClientUserAuth().subscribe(auth => {
                this.view = auth[0].viewFlag;
                this.add = auth[0].addFlag;
                this.edit = auth[0].editFlag;
                this.del = auth[0].deleteFlag;
                this.clientId = auth[0].clientId;
                this.baseFlag = auth[0].baseFlag;
                this.onPageLoad();
            });
        }
    }

    onPageLoad() {
        // this.formData = {
        //     'clientId': this.clientId,
        //     'createdBy': this.messageService.getUserId(),
        //     'type': 'type',
        //     'user_id': this.messageService.getUserId()
        // };

        this._rest.getTicketType(this.clientId).subscribe((res1) => {
            this.respObject = res1;
            if (this.respObject.success) {
                this.isError = false;
                this.respObject.details.unshift({ id: 0, name: 'Select Ticket Type' });
                this.tickets = this.respObject.details;
                this.ticketSelected = 0;
            } else {
                this.notifier.notify('error', this.respObject.errorMessage);
            }
        }, (err) => {
            this.notifier.notify('error', JSON.stringify(err));
        });
        if (this.clientId === 2) {
            this.isShow = true;
        }
        this.dataLoaded = true;
        //  this.getTableData();
    }

    changeRouting(path: string) {
        this.messageService.changeRouting(path);
    }


    exportToExcel() {
        this._rest.getAllCategory(this.clientId).subscribe((res1) => {
            this.respObject = res1;
            if (this.respObject.success) {
                this.dataExcel = this.respObject.details;
                console.log('true' + JSON.stringify(this.dataExcel));
                this.messageService.exportAsExcelFile(this.dataExcel);
            } else {
                this.notifier.notify('error', this.respObject.errorMessage);
            }
        }, (err) => {
            this.notifier.notify('error', this.messageService.SERVER_ERROR);
        });
    }

    openModal(content) {
        if (!this.messageService.add) {
            this.notifier.notify('error', 'You do not have add permission');
        } else {
            this.selectedActionValue = 1;
            this.urgencieName = '';
            this.urgencies = [];
            this.categoryParentName = '';
            this.categories = [];
            this.priorityName = '';
            this.priorities = [];

            this.priorityType = 0;
            this.prioritySelected = 0;
            this.categorySelected = 0;
            this.urgencySelected = 0;
            this.impacts = [];
            this.impactSelected = 0;
            this.templatebtndisabled = false;
            this.templateDownloadMessage = '';
            this.updateStatus = [{ id: 'new', name: 'New' },
            { id: 'low', name: 'Low' },
            { id: 'high', name: 'High' }];
            this.isError = false;
            this.areaSelected = 0;
            this.updateStatusSelected = 'new';
            this.seq = 0;
            this.formData = {
                'clientId': this.clientId,
                'createdBy': this.messageService.getUserId(),
                'type': 'type',
                'user_id': this.messageService.getUserId(),
                'updateStatusSelected': this.updateStatusSelected
            };
            this.attachClaimNo = false;
            this.enablePriority = false;
            this.tabClick();
            this.modalService.open(content, { size: 'lg' }).result.then((result) => {
            }, (reason) => {
            });
        }
    }

    reset() {
        this.ics = [];
        this.levels = [];
        this.page_no = 0;
        this.nextOffset = 0;
        this.categoryName = '';
        this.icSelected = 0;
        this.levelSelected = 0;
        this.ticketSelected = 0;
        this.dataLoaded = true;
        //  this.getTableData();
    }

    resetSearch() {
        this.ics = [];
        this.levels = [];
        this.categoryName = '';
        this.icSelected = 0;
        this.levelSelected = 0;
        this.ticketSelected = 0;
    }

    searchModal() {
        this.ticketSelected = 0;
        this.categoryName = '';
        this.ics = [];
        this.levels = [];
        this.isSearch = false;
        this.searchModalReference = this.modalService.open(this.scarch_content);
        this.searchModalReference.result.then((result) => {
        }, (reason) => {

        });

    }


    onChangeUpdateStatus(selectedIndex: any) {
        this.formData = {
            'clientId': this.clientId,
            'createdBy': this.messageService.getUserId(),
            'type': 'type',
            'user_id': this.messageService.getUserId(),
            'updateStatusSelected': this.updateStatusSelected
        };
    }

    save() {
        const data = {
            clientId: this.clientId,
            attrId: 1,
            attrVal: this.attrVal,
            attrDesc: this.attrDesc,
            attrHeadMstId: this.areaSelected,
            createdBy: this.messageService.getUserId(),
            attachClaimNo: this.attachClaimNo
        };
        // if (Number(this.attrSelected) === 1) {
        //   data['attrHeadMstId'] = this.areaSelected;
        // }
        if (!this.messageService.isBlankField(data)) {
            data['parentId'] = this.parentSelected;

            if (this.selectedActionValue === 1) {
                this.dataLoaded = false;
                this._rest.insertTicketAttributesClientWise(data).subscribe((res) => {
                    this.respObject = res;
                    if (this.respObject.success) {
                        this.isError = false;
                        this.id = this.respObject.details;
                        this.messageService.setRow({
                            id: this.id,
                            area: this.areaName,
                            parent: this.parentName,
                            name: this.attrVal,
                            description: this.attrDesc,
                            attachedField: this.attachClaimNo
                        });
                        this.totalData = this.totalData + 1;
                        this.messageService.setTotalData(this.totalData);

                        if (this.totalData <= this.pageSize * this.page_no) {
                            this.offset = this.id;
                            this.nextOffset = 0;
                        } else {
                            this.nextOffset = this.offset;
                        }
                        // this.getBaseParent();
                        // this.parents.push({id: id, name: this.attrVal});
                        this.areaSelected = 0;
                        this.parentSelected = 0;
                        this.attrDesc = '';
                        this.attrVal = '';
                        this.attachClaimNo = false;
                        this.seq = 0;
                        this.notifier.notify('success', 'Added');
                        this.dataLoaded = true;
                        this.ticketTypes = [];

                    } else {
                        this.isError = true;
                        this.errorMessage = this.respObject.errorMessage;
                        this.dataLoaded = true;
                    }
                }, (err) => {
                    this.isError = true;
                    this.errorMessage = this.messageService.SERVER_ERROR;
                    this.dataLoaded = true;
                });
            } else if (this.selectedActionValue === 2) {
                const data = {
                    ATTRVAL: this.attrVal, Attr_desc: this.attrDesc, user_id: this.messageService.getUserId(), id: this.parentSelected
                };
                console.log('data---' + JSON.stringify(data));
                this.dataLoaded = false;
                if (this.parentSelected == 0) {
                    this.notifier.notify('error', 'Please Select Parent Category');
                } else {
                    this._rest.updateTicketAttributesClientWise(data).subscribe((res) => {
                        this.respObject = res;
                        if (this.respObject.success) {
                            this.dataLoaded = true;
                            this.notifier.notify('success', 'Updated Successfully');
                            this.areaSelected = 0;
                            this.parentSelected = 0;
                            this.attrDesc = '';
                            this.attrVal = '';
                            this.attachClaimNo = false;
                            this.seq = 0;
                            this.ticketTypes = [];
                        } else {
                            this.dataLoaded = true;
                            this.notifier.notify('error', this.respObject.errorMessage);
                        }
                    }, (err) => {
                        this.dataLoaded = true;
                        this.notifier.notify('error', this.respObject.errorMessage);
                    });
                }

            }
        } else {
            this.isError = true;
            this.errorMessage = this.messageService.BLANK_ERROR_MESSAGE;
        }
    }

    getTableData() {
        if (!this.messageService.view) {
            this.notifier.notify('error', 'You do not have view permission');
        } else {
            this.getData({ 'offset': this.nextOffset, 'paginationType': '' });
        }
    }

    isEmpty(obj) {
        for (const key in obj) {
            if (obj.hasOwnProperty(key)) {
                return false;
            }
        }
        return true;
    }

    selectedActionValue1: number;
    getData(paginationObj) {
        const offset = paginationObj.offset;
        const paginationType = paginationObj.paginationType;
        this.dataLoaded = false;

        if (this.selectedActionValue1 === 2) {
            this._rest.getTicketAttributesClientWise(this.clientId, offset, this.pageSize, paginationType, "Search_By_Drop_Down_Module",
                this.SelectDropDownId, "2").subscribe((res) => {
                    this.respObject = res;
                    this.executeResponse(this.respObject, offset, paginationType);
                }, (err) => {
                    this.notifier.notify('error', JSON.stringify(err));
                });
        } else {
            this._rest.getTicketAttributesClientWise(this.clientId, offset, this.pageSize, paginationType, this.categoryName, this.levelSelected, this.icSelected).subscribe((res) => {
                this.respObject = res;
                this.executeResponse(this.respObject, offset, paginationType);
            }, (err) => {
                this.notifier.notify('error', JSON.stringify(err));
            });
        }


    }

    search() {
        this.dataLoaded = false;
        const paginationObj = {
            offset: 0,
            paginationType: ''
        }
        if (this.ticketSelected === 0 || this.icSelected === 0 && this.selectedActionValue1 == 1) {
            this.notifier.notify('error', 'Select ticket type and first category');
        } else {
            this.searchModalReference.close();
            this.getData(paginationObj);
        }
    }

    executeResponse(respObject, offset, paginationType) {
        if (respObject.success) {
            this.dataLoaded = true;
            if (offset === 0) {
                this.totalData = respObject.details.totalData[0].count;
                this.totalPage = respObject.details.totalPage;
                if (this.totalPage === 0) {
                    this.totalPage = 1;
                }
            }
            if (!this.isEmpty(respObject.details.dataObj)) {
                const data = respObject.details.dataObj;
                this.nextOffset = respObject.details.nextOffset;
                this.offset = respObject.details.nextOffset;
                this.previousOffset = respObject.details.previousOffset;
                this.messageService.setTotalData(this.totalData);
                this.messageService.setGridData(data);
                // ----------------------------------------------
                if (offset !== 0) {
                    const totalCount = this.totalData;
                    const divRes = totalCount / this.pageSize;
                    const remainder = totalCount % this.pageSize;
                    if (remainder === 0) {
                        this.totalPage = parseInt(String(divRes), 10);
                    } else {
                        this.totalPage = parseInt(String(divRes), 10) + 1;
                    }
                }
                // ------------------------------------------------
                if (paginationType === 'next') {
                    this.page_no = this.page_no + 1;
                } else if (paginationType === 'prev') {
                    this.page_no = this.page_no - 1;
                } else if (paginationType === '' && this.page_no === 0) {
                    this.page_no = this.page_no + 1;
                }
                if (this.totalData <= this.pageSize * this.page_no) {
                    this.nextOffset = 0;
                }
            } else if (this.isEmpty(respObject.details.dataObj) && paginationType === 'next') {
                this.nextOffset = 0;
            } else if (this.isEmpty(respObject.details.dataObj) && paginationType === 'prev') {
                this.previousOffset = 0;
            } else if (paginationType === '' && this.page_no === 0) {
                this.page_no = this.page_no + 1;
            }
        } else {
            this.notifier.notify('error', respObject.errorMessage);
        }
    }

    onPageSizeChange(value: any) {
        this.page_no = 0;
        this.nextOffset = 0;
        this.pageSize = value;
        this.getData({ 'offset': this.nextOffset, 'paginationType': '' });
    }


    onAreaChange(selectedIndex: any) {
        this.areaName = this.areas[selectedIndex].name;
        this.seq = this.areas[selectedIndex].seq;
        this.dataLoaded = false;
        this.ticketTypes = [];
        if (this.seq > 1 && this.selectedActionValue == 1 || this.seq > 0 && this.selectedActionValue == 2) {
            for (let i = 1; i < this.areas.length; i++) {
                console.log(this.areas[i].name);
                if (this.selectedActionValue === 1) {
                    if (this.areas[i].seq === this.seq) {
                        break;
                    } else {
                        this.ticketTypes.push({ id: i, isDisabled: false, options: [{ id: this.areas[i].id, name: this.areas[i].name }] });
                    }
                } else {
                    let val = this.seq + 1
                    if (this.areas[i].seq === val) {
                        break;
                    } else {
                        this.ticketTypes.push({ id: i, isDisabled: false, options: [{ id: this.areas[i].id, name: this.areas[i].name }] });
                    }
                }

            }
            console.log('BEFORE ==> ' + JSON.stringify(this.ticketTypes));
            this._rest.getTicketAttrClientAttributesWise(this.clientId, 2, this.ticketSelected).subscribe((res) => {
                // this._rest.getAttributesParentWise(this.clientId, 0).subscribe((res) => {
                this.respObject = res;
                if (this.respObject.success) {
                    this.isError = false;
                    // let resobj = [];
                    // for (let i = 0; i < this.respObject.details.length; i++) {
                    //     resobj.push({ id: this.respObject.details[i].id, name: this.respObject.details[i].title });
                    // }
                    // resobj.unshift({ id: this.ticketTypes[0].options[0].id, name: this.ticketTypes[0].options[0].name });
                    // this.ticketTypes[0].options = resobj;

                    this.respObject.details.unshift({ id: this.ticketTypes[0].options[0].id, name: this.ticketTypes[0].options[0].name });
                    this.ticketTypes[0].options = this.respObject.details;
                    this.dataLoaded = true;
                    console.log('After ==> ' + JSON.stringify(this.ticketTypes));
                } else {
                    this.isError = true;
                    this.errorMessage = this.respObject.errorMessage;
                    this.dataLoaded = true;
                }
            }, (err) => {
                this.dataLoaded = true;
                this.isError = true;
                this.errorMessage = this.messageService.SERVER_ERROR;
            });

        } else {
            this.dataLoaded = false;
            this._rest.getTicketAttrClientAttributesWise(this.clientId, this.seq, this.ticketSelected).subscribe((res1) => {
                this.respObject = res1;
                if (this.respObject.success) {
                    this.dataLoaded = true;
                    this.isError = false;
                    this.respObject.details.unshift({ id: 0, name: 'Base Parent' });
                    this.parents = this.respObject.details;
                    this.parentSelected = 0;
                } else {
                    this.dataLoaded = true;
                    this.isError = true;
                    this.errorMessage = this.respObject.errorMessage;
                }
            }, (err) => {
                this.dataLoaded = true;
                this.isError = true;
                this.errorMessage = this.messageService.SERVER_ERROR;
            });
        }

    }


    onParentChange() {
        // this.parentName = this.parents[selectedIndex].name;
        for (let i = 0; i < this.parents.length; i++) {
            if (this.parentSelected === this.parents[i].id) {
                this.parentName = this.parents[i].name;
                break;
            }
        }
        console.log(this.parentName)
    }


    ticketTypes2 = [];
    onTicketChange3(selectedIndex: any) {
        this._rest.getTicketCreateLoadingDtls(this.messageService.getUserId(), this.tickets[selectedIndex].id,
            this.clientId).subscribe((res) => {
                this.respObject = res;
                if (this.respObject.success) {
                    this.ticketTypes2 = this.respObject.details[0].attribute;
                }
            });
    }




    onTicketChange(selectedIndex: any) {
        this.type = this.tickets[selectedIndex].name;
        this._rest.getAttributesHeaderMstClientTicketTypeWise(this.clientId, this.ticketSelected).subscribe((res1) => {
            this.respObject = res1;
            if (this.respObject.success) {
                this.isError = false;
                this.respObject.details.unshift({ id: 0, name: 'Select Process Area ' });
                this.areas = this.respObject.details;
                this.areaSelected = 0;
            } else {
                this.isError = true;
                this.errorMessage = this.respObject.errorMessage;
            }
        }, (err) => {
            this.isError = true;
            this.errorMessage = this.messageService.SERVER_ERROR;
        });
        this._rest.getCategoryIc(this.clientId, this.ticketSelected).subscribe((res1) => {
            this.respObject = res1;
            if (this.respObject.success) {
                this.isError = false;
                this.respObject.details.unshift({ id: 0, name: 'Select First Category' });
                this.ics = this.respObject.details;
                // this.icSelected = 0;
            } else {
                this.notifier.notify('error', this.respObject.errorMessage);
            }
        }, (err) => {
            this.notifier.notify('error', JSON.stringify(err));
        });

        this._rest.getCategoryLevel(this.clientId, this.ticketSelected).subscribe((res1) => {
            this.respObject = res1;
            if (this.respObject.success) {
                this.isError = false;
                this.respObject.details.unshift({ id: 0, name: 'Select level' });
                this.levels = this.respObject.details;
                this.levelSelected = 0;
            } else {
                this.notifier.notify('error', this.respObject.errorMessage);
            }
        }, (err) => {
            this.notifier.notify('error', JSON.stringify(err));
        });
    }

    onFileComplete(data: any) {
        if (data.success) {
            // this.attachment = data.fileName;
            alert(this.messageService.UPLOAD_MESSAGE);
            this.isError = false;
        } else {
            this.isError = true;
            this.errorMessage = data.errorMessage;
        }
    }
    tabClick() {
        this.ticketSelected = 0;
        this.categories = [];
    }
    downloadTemplate() {
        if (this.ticketSelectedForTemplate === 0) {
            alert(this.messageService.BLANK_ERROR_MESSAGE);
            return;
        }
        this._rest.getTicketCategoryTemplate(this.clientId, this.ticketSelectedForTemplate, this.enablePriority).subscribe((res1) => {
            this.templatebtndisabled = true;
            this.templateDownloadMessage = '<span>Please wait while generating template</span>';
            this.respObject = res1;
            if (this.respObject.success) {
                this.templatebtndisabled = false;
                this.templateDownloadMessage = '<a class=\'download-link\' target=\'blank\' href=\'' +
                    this.messageService.ASSET_REPORT_PATH + this.respObject.resVal.filename + '\'>Download</a>';
                console.log(res1);

            } else {
                this.notifier.notify('error', this.respObject.errorMessage);
                this.templatebtndisabled = false;
                this.templateDownloadMessage = '';
            }
        }, (err) => {
            this.notifier.notify('error', this.messageService.SERVER_ERROR);
            this.templatebtndisabled = false;
            this.templateDownloadMessage = '';
        });
    }



    onUrgencyChange(selectedIndex: any) {
        this.urgencieName = this.urgencies[selectedIndex].name;
    }

    onCategoryChange(selectedIndex: any) {
        // this.categoryParentName = this.categories[selectedIndex].name;
        // console.log(this.categoryName, this.categories[selectedIndex].id);
        for (let i = 0; i < this.categories.length; i++) {
            if (this.categorySelected === this.categories[i].id) {
                this.categoryParentName = this.categories[i].name;
                break;
            }
        }
        console.log(this.categoryName);
    }

    onPriorityChange(selectedIndex: any) {
        this.priorityName = this.priorities[selectedIndex].name;
    }

    onTicketChange1(selectedIndex: any) {
        this.type = this.tickets[selectedIndex].name;
        this.dataLoaded = false;
        this._rest.getPriorityMapping(this.clientId, this.ticketSelected).subscribe((res1) => {
            this.respObject = res1;
            if (this.respObject.success) {
                this.dataLoaded = true;
                this.isError = false;
                this.priorityType = this.respObject.details[0].ticket_priority_type;
                this.respObject.details[0].priority.unshift({ id: 0, name: 'Select Priority' });
                this.priorities = this.respObject.details[0].priority;
                this.prioritySelected = 0;
                if (this.priorityType === 2) {
                    this.respObject.details[0].category.unshift({ id: 0, name: 'Select Category' });
                    this.categories = this.respObject.details[0].category;
                    this.categorySelected = 0;
                }
                if (this.priorityType === 1) {
                    this.respObject.details[0].urgency.unshift({ id: 0, name: 'Select Urgency' });
                    this.urgencies = this.respObject.details[0].urgency;
                    this.urgencySelected = 0;
                    this.respObject.details[0].impact.unshift({ id: 0, name: 'Select Impact' });
                    this.impacts = this.respObject.details[0].impact;
                    this.impactSelected = 0;
                }
            } else {
                this.dataLoaded = true;
                this.isError = true;
                this.errorMessage = this.respObject.errorMessage;
            }
        }, (err) => {
            this.dataLoaded = true;
            this.isError = true;
            this.errorMessage = this.messageService.SERVER_ERROR;
        });
    }

    saveMatrix() {
        let data;
        if (this.priorityType === 1) {
            data = {
                clientId: this.clientId,
                busi_impact_id: this.impactSelected,
                busi_urgency_id: this.urgencySelected,
                busi_priority_id: this.prioritySelected,
                type: this.priorityType,
                ticket_type: this.ticketSelected,
                createdBy: this.messageService.getUserId()
            };
        } else {
            data = {
                clientId: this.clientId,
                categoryId: this.categorySelected,
                busi_priority_id: this.prioritySelected,
                type: this.priorityType,
                ticket_type: this.ticketSelected,
                createdBy: this.messageService.getUserId()
            };
        }
        if (!this.messageService.isBlankField(data)) {
            // console.log(JSON.stringify(data));
            this._rest.insertBusinessMatrix(data).subscribe((res) => {
                this.respObject = res;
                if (this.respObject.success) {
                    this.isError = false;
                    this.id = this.respObject.id;
                    this.notifier.notify('success', 'Added');
                    if (this.priorityType === 1) {

                    } else {
                        this.messageService.setRow({
                            id: this.id,
                            area: ' ',
                            parent: ' ',
                            name: this.categoryParentName,
                            description: this.categoryParentName,
                            prority: this.priorityName
                        });
                    }

                    this.impactSelected = 0;
                    this.urgencySelected = 0;
                    this.prioritySelected = 0;
                } else {
                    this.isError = true;
                    this.errorMessage = this.respObject.errorMessage;
                }
            }, (err) => {
                this.isError = true;
                this.errorMessage = this.messageService.SERVER_ERROR;
            });
        } else {
            this.isError = true;
            this.errorMessage = this.messageService.BLANK_ERROR_MESSAGE;
        }
    }

    SelectDropDownId: number;
    onCategoryChangeDropDown1(val1, val2) {
        //console.log(JSON.stringify(val1) + ' -- ' + JSON.stringify(val2));
        const opt = JSON.parse(val2);
        console.log(this.ticketTypes2.length + ' -- ' + val1.id);
        this.SelectDropDownId = opt.id;
        if (this.ticketTypes.length === val1.id) {
            console.log('this.selectedParentCategoryId ==> ' + opt.id);
            this.parentSelected = opt.id;
        } else {
            this.dataLoaded = false;
            this._rest.getAttributesParentWise(this.clientId, opt.id).subscribe((res) => {
                this.respObject = res;
                if (this.respObject.success) {
                    console.log(val1.id);
                    //console.log(JSON.stringify(this.ticketTypes));
                    let nextid = val1.id;
                    console.log(nextid + ' --- NEEXT CAT DROPDOWN' + JSON.stringify(this.ticketTypes2[nextid]));

                    let resobj = [];
                    for (let i = 0; i < this.respObject.details.length; i++) {
                        resobj.push({ id: this.respObject.details[i].id, title: this.respObject.details[i].title });
                    }

                    resobj.unshift({
                        id: this.ticketTypes2[nextid].options[0].id, title: this.ticketTypes2[nextid].options[0].title
                    });
                    this.ticketTypes2[val1.id].options = resobj;
                    this.dataLoaded = true;

                } else {
                    this.dataLoaded = true;
                    // this.notifier.notify('error', this.messageService.SERVER_ERROR);
                }
            }, (err) => {
                this.dataLoaded = true;
                // this.notifier.notify('error', this.messageService.SERVER_ERROR);
            });
        }
        this.dataLoaded = true;
    };




    onCategoryChangeDropDown(val1, val2) {
        //console.log(JSON.stringify(val1) + ' -- ' + JSON.stringify(val2));
        const opt = JSON.parse(val2);
        console.log(this.ticketTypes.length + ' -- ' + val1.id);
        if (this.ticketTypes.length === val1.id) {
            console.log('this.selectedParentCategoryId ==> ' + opt.id);
            this.parentSelected = opt.id;
        } else {
            this.dataLoaded = false;
            this._rest.getAttributesParentWise(this.clientId, opt.id).subscribe((res) => {
                this.respObject = res;
                if (this.respObject.success) {
                    console.log(val1.id);
                    //console.log(JSON.stringify(this.ticketTypes));
                    let nextid = val1.id;
                    console.log(nextid + ' --- NEEXT CAT DROPDOWN' + JSON.stringify(this.ticketTypes[nextid]));

                    let resobj = [];
                    for (let i = 0; i < this.respObject.details.length; i++) {
                        resobj.push({ id: this.respObject.details[i].id, name: this.respObject.details[i].title });
                    }

                    resobj.unshift({
                        id: this.ticketTypes[nextid].options[0].id, name: this.ticketTypes[nextid].options[0].name
                    });
                    this.ticketTypes[val1.id].options = resobj;
                    this.dataLoaded = true;

                } else {
                    this.dataLoaded = true;
                    this.notifier.notify('error', this.messageService.SERVER_ERROR);
                }
            }, (err) => {
                this.dataLoaded = true;
                this.notifier.notify('error', this.messageService.SERVER_ERROR);
            });
        }
        this.dataLoaded = true;
    };

    onRadioChange() {
        console.log('selectedActionValue ==> ' + this.selectedActionValue);
        this.areaSelected = 0;
        this.parentSelected = 0;
        this.attrDesc = '';
        this.attrVal = '';
        this.attachClaimNo = false;
        this.seq = 0;
        this.ticketTypes = [];

    }

    ngOnDestroy(): void {
        if (this.userAuth) {
            this.userAuth.unsubscribe();
        }
    }
}
